import { render, staticRenderFns } from "./navbar_search_desktop.vue?vue&type=template&id=bd857f8a&scoped=true&lang=pug"
import script from "./navbar_search_desktop.vue?vue&type=script&lang=js"
export * from "./navbar_search_desktop.vue?vue&type=script&lang=js"
import style0 from "./navbar_search_desktop.vue.css?vue&type=style&index=0&id=bd857f8a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd857f8a",
  null
  
)

export default component.exports